<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
    :width="$vuetify.breakpoint.smAndDown ? null : 900"
  >
    <div class="grid gap5">
      <GoogleAutocomplete
        :street="data.street"
        :zip="data.zip"
        :city="data.city"
        :on-change="changeAddress"
      />
      <div>
        <BaseInput
          :label="t['address']['filial']"
          :label-second="t['address']['sozdayte-novyy-ili-vyberite-v-spiske']"
          v-model="data['work_client_office_id']"
          type="autocomplete"
          :items="officeList"
          :rules="['required']"
        >
        <WorkClientOfficesModal create :client-id="$route.params.id" :text="textOffice" minimalize/>
        </BaseInput>
        <BaseInput
          :label="t['address']['opisanie']"
          v-model="data.description"
          type="textarea"
          class="mt-5"
        />
      </div>
    </div>
  </TemplateModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import GoogleAutocomplete from "components/google/autocomplete/GoogleAutocomplete"
import WorkClientOfficesModal from "components/workClient/offices/WorkClientOfficesModal";

export default {
  name: 'WorkClientAddressModal',
  components: {WorkClientOfficesModal, GoogleAutocomplete},
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    create: Boolean
  },
  data: () => ({
    dialog: false,
    data: {},
  }),
  computed: {
    ...mapGetters('workClientOffices', { officeList: 'workClientOfficesAll'}),
    t() {
      return this.localStorage.translations.pages['setting-client']
    },
    text() {
      return {
        button: {
          open: this.t['address-dialog-add_edit-butons']['dobavit-adres'],
        },
        title: {
          create: this.t['address-dialog-add_edit']['dobavlenie-adresa'],
          edit: this.t['address-dialog-add_edit']['redaktirovanie-adresa']
        }
      }
    },
    textOffice() {
      return {
        button: {
          open: this.t['offices-dialog-add_edit-buttons']['sozdat-filial'],
        },
        title: {
          create: this.t['offices-dialog-add_edit']['sozdanie-filiala'],
        }
      }
    },
    params() {
      return {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
        id: this.$route.params.id,
      }
    }
  },
  methods: {
    ...mapActions('workClientAddress', [
      'onWorkClientAddressShow',
      'onWorkClientAddressCreate',
      'onWorkClientAddressGrid',
      'onWorkClientAddressUpdate',
    ]),
    ...mapActions('workClientOffices', ['onWorkClientOfficesAll']),
    async onOpen() {
      await this.onWorkClientOfficesAll(this.$route.params.id)
      if (this.id)
        await this.onWorkClientAddressShow(this.id)
          .then(res => {
            this.data = res.data.data
            this.data.work_client_office_id = this.data['office'].id
          })
      else
        this.data = {}
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
    },
    async onSave() {
      this.data.work_client_id = this.$route.params.id
      if (this.data.id) {
        await this.onWorkClientAddressUpdate(this.data)
          .then(() => {
            this.onWorkClientAddressGrid(this.params)
          })
      } else {
        await this.onWorkClientAddressCreate(this.data)
          .then(() => {
            this.onWorkClientAddressGrid(this.params)
          })
      }
    },
    changeAddress(data) {
      this.data.street = data.street
      this.data.zip = data.zip
      this.data.city = data.city
    }
  },
}
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    grid-template-columns: 1fr;
  }
}
</style>
